export const HEIGHT_FROM_TOP_TO_REWARDS_RANK = 130;
export const HEIGHT_REWARD = 18.2;
export const HEIGHT_FROM_LAST_REWARD_RANK_TO_FIRST_REWARD_LEVEL = 40;
export const MARGIN_REWARD = 4;
